import { FolderNode, FolderType } from 'types/sequences';

interface FolderNodeWithAncestors {
  folder?: FolderNode;
  ancestors: { id: string; title: string; type: FolderType }[];
}

export function findFolderNodeWithAncestors(
  folders: FolderNode[],
  folderId: string,
  ancestors: { id: string; title: string; type: FolderType }[] = [],
): FolderNodeWithAncestors | undefined {
  for (const folder of folders) {
    if (folder.id === folderId) {
      return { folder, ancestors };
    }

    if (folder.children) {
      const childrenResult = findFolderNodeWithAncestors(
        folder.children || [],
        folderId,
        [
          ...ancestors,
          { id: folder.id, title: folder.title, type: folder.type },
        ],
      );
      if (childrenResult) {
        return childrenResult;
      }
    }
  }

  return undefined;
}
